module.exports = __webpack_public_path__ + "img/tutorial-pc-page5.4726a532.png";